// frontend/src/redux/notesRelated/notesSlice.js
import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// Async Thunks
export const fetchNotes = createAsyncThunk('notes/fetchNotes', 
  async (studentId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/notes/${studentId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchTeacherNotes = createAsyncThunk('notes/fetchTeacherNotes', 
  async (teacherId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/notes/teacher/${teacherId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const sendNote = createAsyncThunk('notes/sendNote',
  async (noteData, { rejectWithValue }) => {
    try {
      const response = await axios.post('/api/notes', noteData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const sendBulkNotes = createAsyncThunk(
  'notes/sendBulkNotes',
  async (noteData, { rejectWithValue }) => {
    try {
      const response = await axios.post('/api/notes/bulk', noteData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const notesSlice = createSlice({
  name: 'notes',
  initialState: { 
    notes: [], 
    loading: false, 
    error: null 
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotes.fulfilled, (state, action) => {
        state.loading = false;
        state.notes = action.payload;
      })
      .addCase(fetchNotes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchTeacherNotes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeacherNotes.fulfilled, (state, action) => {
        state.loading = false;
        state.notes = action.payload;
      })
      .addCase(fetchTeacherNotes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(sendNote.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendNote.fulfilled, (state, action) => {
        state.loading = false;
        state.notes.push(action.payload);
      })
      .addCase(sendNote.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(sendBulkNotes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(sendBulkNotes.fulfilled, (state, action) => {
        state.loading = false;
        state.notes = [...state.notes, ...action.payload.notes];
    })
      .addCase(sendBulkNotes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const notesReducer = notesSlice.reducer;